module.exports = __webpack_public_path__ + "img/ic_notification-active.0d278987.svg";